import { Flex, Stack, Title } from '@mantine/core';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { FC, FormEvent, useState } from 'react';
import EastIcon from '@mui/icons-material/East';
import { useTranslation } from 'react-i18next';
import { PageFooter, StepProps } from '../../../shared_components';
import { usePriceApi } from '../../../shared_hooks';
import classes from '../../../app.module.css';

export const CheckoutForm: FC<StepProps> = ({ forward, back }) => {
  const { t } = useTranslation(['payment', 'common']);
  const price = usePriceApi();
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/measurement/validating`,
      },
    });

    if (error && error.message) {
      setMessage(error.message);
      console.log(message);
    }

    setIsProcessing(false);
  };

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <form onSubmit={handleSubmit}>
      <Flex direction={'column'} justify={'space-between'} h={'100%'}>
        <Stack
          gap={'var(--mantine-spacing-lg)'}
          classNames={{ root: classes.footerPadding }}
        >
          <PaymentElement
            options={{ layout: { type: 'tabs', defaultCollapsed: false } }}
          />

          <Flex justify={'space-between'}>
            <Title order={2}>{t('sum')}</Title>
            <Title order={2}>{price}</Title>
          </Flex>
        </Stack>

        <PageFooter
          leftOnClick={back}
          buttonText={t('confirm_payment')}
          buttonIcon={<EastIcon />}
          submitButton={true}
          disabled={isProcessing}
        />
      </Flex>
    </form>
  );
};
